const ClassificationIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <p className="tw-header">Classification</p>
        </div>
    )
}

export default ClassificationIntro;